/**
* Defines the global array to capture the parameters in URL for email address deletion before Google Analytics tags in "Manage subscription" forms.
*
* @deprecated old value but kept for backward compatibility.  @see {@link BDC.urlParams} which replaces this one.
* @type object
*/
var urlParams = [];

(function ($, document, window, BDC) {
    "use strict";

    BDC.currentUrl = window.location.href;
    BDC.currentLang = String(navigator.language).substring(0, 2);
    const documentLang = document.getElementsByTagName("html")[0].lang.substring(0, 2);

    /**
    * The list of domains
    * @prop 
    * @type string
    */
    BDC.domainsList = {
        'prod': { 'domain': "www.bdc.ca", 'environnement': "prod", 'type': "live" },
        'prodCms12': { 'domain': "prod12.bdc.ca", 'environnement': "prod", 'type': "live" },
        'test': { 'domain': "prep.bdc.ca", 'environnement': "test", 'type': "live" },
        'dev': { 'domain': "inte.bdc.ca", 'environnement': "dev", 'type': "live" },
        'ia': { 'domain': "ade2.bdc.ca", 'environnement': "dev", 'type': "live" },
        'local': { 'domain': "localhost", 'environnement': "local", 'type': "live" },
        'eloqua': { 'domain': "services.bdc.ca", 'environnement': "prod", 'type': "live" },
        'surveyGizmo': { 'domain': "ca.surveygizmo.com", 'environnement': "prod", 'type': "live" },
        'alchemer': { 'domain': "survey.alchemer-ca.com", 'environnement': "prod", 'type': "live" }
    };

    /**
    * Get all parameters from url.  Used for email buttons that contains parameters for subscription options.  
    *
    * @function getParams
    * @memberof BDC.Main
    * @see {@link urlParams}
    */
    function getParams() {
        var n;
        const a = window.location.href.split("?");
        if (a.length > 1) {
            const t = [];
            for (var r = a[1], e = r.split("&"), s = 0; s < e.length; s++) {
                n = e[s].split("=");
                t.push(n[0]);
                t[n[0]] = n[1];
            }

            if (t["elqCampaignId"] !== undefined) {
                t["elqCampaignId"] = window.location.hash.split("&")[0];
            }

            if (/(manage-subscriptions|gerez-abonnements|manage-preferences|gerez-preferences)/.test(window.location
                .href)) {
                window.location.hash = "";
            }

            return t;
        }
        return false;
    }

    /**
    * In some pages, this inline property will override the current page URL for social media counters.  
    * Examples of pages would be "Thank you", "informations sent", and so on.
    *
    * @type object
    * @memberof BDC
    */
    BDC.urlParams = urlParams = getParams();

    //pull lang attribute out of html document which may be different from browser language
    //use html language attribute to pick translation dictionary
    if(documentLang.match(BDC.currentLang)==null){
        BDC.currentLang = documentLang;
    }

    /**
	 * Define load sub-namespace object.
	 * @namespace load
	 * @memberOf BDC
 	 */

    BDC.load = (function() {
        // Private properties
        // Object containing different scope properties for execution
        var funcs = {},
		// Functions push with public "ready" method. Those function are execute before "funcs"
			waitReady = [];

        /**
		 * Private: Add an execution scope. This define an array to push methods for execution on document ready.
		 * @param {string} scope Namespace name of the scope
		 * @returns {array} Newly scope array.
		 */
        function addScope(scope) {
            if(!funcs[scope]) {
                funcs[scope] = [];
            }
            return funcs[scope];
        }
        /**
		 * Private: Add an execution methods to a specific scope.
		 * @param {string} scope Name of namespace to add the method to for execution
		 * @param {string|Array|function} method Name of the method to execute in the namespace or an anonymous function. Can be an array of methods to push more than one method in a single call.
		 * @param {array} [args] Opional - Arguments array to pass to the method on execution
		 * @returns {array} Scope array
		 */
        function push(scope, method, args) {
            var i;
            if(!funcs[scope]) {
                addScope(scope);
            }
            // Register more than one functions
            if($.isArray(method)) {
                // Loop in method array
                for(i=0;method[i];i++) {
                    // If current method is an array, this refer to a method with arguments to be pass on execution. Use this format [method, [arguments_list]]
                    if($.isArray(method[i])) {
                        push(scope, method[i][0],  method[i].slice(1));
                    } else {
                        push(scope, method[i]);
                    }
                }
            } else {
                funcs[scope].push([method, (args||[])]);
            }
            // Return the scope array
            return funcs[scope];
        }
        /**
		 * Private: Execute all registered methods added with _push
		 * @returns {undefined}
		 */
        function exec() {
            var space, scope, func, args, isFunc, funcName, i;
            if(BDC.console) {
                BDC.console.time("All registered Group & Events:");
            }
            // Loop through all scope in funcs
            for(scope in funcs) {
                if(funcs.hasOwnProperty(scope)) {
                    space = BDC.Utils.parseNameSpace(scope);
                    if(BDC.console) {
                        BDC.console.group((space ? scope : "window") + '" registered methods:');
                        BDC.console.time(`Group "${space ? scope : "window"}" execution time:`);
                    }
                    for(i=0; funcs[scope][i]; i++) {
                        isFunc = $.isFunction(window[funcs[scope][i]]); //$.isArray(funcs[scope][i]);
                        // A function was added without a defined namespace or out of a namespace context
                        if((space===false) || isFunc) {
                            funcName = "anonymous";
                            // No arguments function
                            if(isFunc) {
                                func = funcs[scope][i];
                                args = [];
                                // An array indicate a proper add with a push with arguments array [method, [args]].
                            } else if ($.isArray(funcs[scope][i]) && funcs[scope][i].length === 2) {
                                func = funcs[scope][i][0];
                                args = funcs[scope][i][1];
                                if(!$.isFunction(func)) {
                                    if(BDC.console) {
                                        BDC.console.warn("L'index 0 doit être une fonction pour être exécuté correctement via le _exec!", funcs[scope][i], func, args);
                                    }
                                    isFunc = func = false;
                                }
                            }
                            // Name space found
                        } else {
                            // No arguments function
                            if(!$.isArray(funcs[scope][i])) {
                                funcName = $.isFunction(space[funcs[scope][i]]) ? funcs[scope][i] : ((!!space[funcs[scope][i]] && $.isFunction(space[funcs[scope][i]].init)) ? funcs[scope][i]+".init" : "unknown!");
                                func = $.isFunction(space[funcs[scope][i]]) ? space[funcs[scope][i]] : ((!!space[funcs[scope][i]] && $.isFunction(space[funcs[scope][i]].init)) ? space[funcs[scope][i]].init : false);
                                args = [];
                                isFunc = (!!func);
                                // An array indicate a proper add with a push with arguments array [method, [args]].
                            } else if ($.isArray(funcs[scope][i]) && funcs[scope][i].length === 2) {
                                func = funcs[scope][i][0];
                                funcName = $.isFunction(space[func]) ? func : ((!!space[func] && $.isFunction(space[func].init)) ? func+".init" : "unknown!");
                                func = $.isFunction(space[func]) ? space[func] : ((!!space[func] && $.isFunction(space[func].init)) ? space[func].init : false);
                                args = funcs[scope][i][1];
                                if(!$.isFunction(func)) {
                                    if(BDC.console) {
                                        BDC.console.warn("L'index 0 doit être une fonction pour être exécuté correctement via le _exec!", funcs[scope][i]);
                                    }
                                    func = false;
                                }
                                isFunc = (!!func);
                            }

                        }
                        if(BDC.console) {
                            BDC.console.time(`Apply name space "${space ? scope : "window"}.${funcName}"...`);
                        }
                        if(isFunc) {
                            func.apply(this, args);
                        } else {
                            if(BDC.console) {
                                BDC.console.warn("load._exec failed to execute ", scope, funcs[scope][i]);
                            }
                        }
                        if(BDC.console) {
                            BDC.console.timeEnd(`Apply name space "${space ? scope : "window"}.${funcName}"...`);
                        }
                    }
                    if(BDC.console) {
                        BDC.console.groupEnd();
                        BDC.console.timeEnd(`Group "${space ? scope : "window"}" execution time:`);
                    }
                }
            }
            if(BDC.console) {
                BDC.console.timeEnd("All registered Group & Events:");
            }
            // Reset funcs
            funcs = {};
        }
        // Accès public aux méthodes
        return {
            addScope: function(scope) {
                return addScope(scope);
            },
            push: function(scope, method, args) {
                return push(scope, method, args);
            },
            getFuncs: function() {
                return funcs;
            },
            run: function() {
                for(let f in waitReady) {
                    if(waitReady.hasOwnProperty(f)) {
                        if($.isFunction(waitReady[f])) {
                            waitReady[f]();
                        } else {
                            BDC.console.warn("run.waitReady failed to execute ", f, waitReady[f]);
                        }
                    }
                }
                exec();
            },
            ready: function(func) {
                waitReady.push(func);
            }
        };
    })();
	
    // Update global scope BDC namespace
    window.BDC = BDC;

    // Auto trigger all self implemented (plugin) functionalities on document ready
    $(function () {
        BDC.load.run();
    });
}(jQuery, document, window, (window.BDC || {})));




(function($, document, window, BDC) {

    if (!window.jQuery) {
        console.error ("jQuery is not loaded!");
    }

    BDC.Utils = $.extend(BDC.Utils, {
        timerStart: Date.now(),

        parseNameSpace: function(sNs, oBase) {
            oBase = oBase || window;
            if(typeof sNs === "string") {
                const parts = sNs.split(".");
                if(parts.length > 1 && typeof oBase[parts[0]] === "object") {
                    // Recursively call parseNameSpace
                    return BDC.Utils.parseNameSpace(parts.splice(1).join("."), oBase[parts[0]]);
                } else {
                    return oBase[parts[0]] || false;
                }
            }
            return sNs;
        },

        getDateNow: function() {
            return Date.now();
        },

        getRunningTimeInMs: function (now, returnTotal) {
            returnTotal = returnTotal || false;
            now = now || BDC.Utils.timerStart;
            return (!returnTotal ? (` -> Function executed in ${(Date.now() - now) / 1000} seconds.`) : `${((Date.now() - BDC.Utils.timerStart) / 1000)} seconds.`);
        },
        
        getHighestInteger: function(array) {
            return Math.max.apply(Math, array);
        }

    });

    window.BDC = BDC;

    BDC.load.push(
        "BDC.Utils",
        [
            "getRunningTimeInMs",
            "parseNameSpace",
            "getDateNow"
        ]
    );

})(jQuery, document, window, (window.BDC || {}));
